import { Component, Input, OnInit } from '@angular/core';
import { Period } from '../models/Period';
import { Results } from '../models/Results';
import { GroupResults } from '../models/GroupResults';

@Component({
  selector: 'app-bodynote',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class BodyNoteComponent implements OnInit {

  constructor() {
  }

  @Input() period: Period;

  @Input()
  results: Results[] = [];

   @Input()
  fresults: Results[] = [];

  groupResults: GroupResults[] = [];

  parseInt(i) {
    return parseInt(i);
  }

   ngOnInit(): void {
    this.getResultsCalc();
  }


  async getResultsCalc() {
  if (this.results.length==0) return;
  this.results.forEach(element => {
        if (element.cours.is_calc) {
             this.fresults.push(element);
         }
       });
   this.groupResults = this.getGroupResults(this.fresults);

  }

 getGroupResults(results: Results[]): GroupResults[] {
  const groupMap = new Map<string, Results[]>();

  for (const result of results) {
    const catCode = result.cours.cat_code;
    if (!groupMap.has(catCode)) {
      groupMap.set(catCode, []);
    }
    groupMap.get(catCode)!.push(result);
  }

  const groupResultsList: GroupResults[] = [];

  for (const [catCode, group] of groupMap.entries()) {
    const categorie = this.period.categories.find(item => item.code === catCode);
    const note = group.reduce((sum, res) => sum + res.note, 0);
    const groupResult = new GroupResults(catCode, categorie, group, note, categorie?.note_total);
    groupResultsList.push(groupResult);
  }

  return groupResultsList;
}
}
